export type PreviewAction =
  | 'page_viewed' | 'state_selected' | 'grade_selected' | 'subject_selected'
  | 'clarification_attempted' | 'request_refined'
  // Which source of standards a teacher picked, and — the reason this exists — how often
  // someone reaches for the one that is not built yet. A "coming soon" nobody asks for is
  // a different decision from one people keep clicking.
  | 'standards_source_selected' | 'standards_upload_requested'
  // Browser-side: the review table opened, with its format and row count.
  | 'standards_review_opened'
  // Browser-side: a failure the teacher was shown, by stage and named reason, and where in
  // the panel they were when they closed it. The server cannot see a CSV it never receives.
  | 'standards_upload_failed' | 'standards_panel_closed'
  // Server-side, one per action, counts and outcome only — never a code or a statement.
  | 'standards_extracted' | 'standards_saved' | 'standards_deleted'
  | 'ask_submitted' | 'standards_found' | 'ask_failed' | 'report_viewed'
  | 'report_view_changed' | 'topic_opened' | 'report_deleted' | 'quota_refused' | 'subscription_refused'
  | 'access_denied' | 'switch_shown' | 'kill_switch_shown' | 'profile_saved'
  | 'subscription_preview_shown' | 'subscription_cta_clicked'
  | 'alternative_product_clicked'
  | 'example_used' | 'ask_started' | 'ask_error_shown' | 'clarification_shown' | 'quota_exhausted_shown'
  | 'new_request_clicked' | 'feedback_clicked' | 'access_retry_clicked' | 'labs_clicked'
  | 'topic_clicked' | 'topic_back_clicked' | 'topic_retry_clicked' | 'topic_error_shown'
  | 'standard_topics_clicked' | 'official_source_clicked' | 'topic_filter_cleared'
  | 'delete_clicked' | 'delete_confirmed' | 'delete_cancelled' | 'delete_failed';
export type EventName = `osa_${PreviewAction}` | `preview_osa_${PreviewAction}`;
export interface AnalyticsEvent { name: EventName; properties: Record<string, string | number | boolean | string[]> }
export function previewOsaAction(action: PreviewAction, properties: AnalyticsEvent['properties'] = {}): AnalyticsEvent {
  return { name: `preview_osa_${action}`, properties };
}
export const posthogEventName = (name: EventName): string => name.startsWith('preview_') ? name : `preview_${name}`;
